<div class="container">
  <div *ngFor="let data of displayedData">
    <span class="time">{{ data.date | date: 'HH:mm' }}</span>
    <span>{{ data.temperature | number:'1.0-0' }}°c</span>
    <span>
      <img width="50px" src="assets/weather-icons/{{ data.icon }}.svg"
    /></span>
  </div>
</div>
